<template>
  <section>
    <template v-if="!isLoading">
      <div class="max-w-8xl mx-auto p-2 bg-white hidden md:block">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div class="px-4 rounded-lg ">
            <h2 class="text-2xl font-bold mb-4">Bienvenido a LumbreTravel</h2>
            <p class="mb-6">Completa las siguientes tareas para aprender a usar nuestra aplicación:</p>
            <ul>
              <li
                v-for="(task, index) in tasks"
                :key="index"
                class="flex items-center justify-between p-2 mt-2 mb-2 border-b border-gray-200"
              >
                <span :class="{ 'line-through text-gray-500': task.completed }">{{ task.description }}</span>
                <div>
                  <button
                    v-if="!task.completed"
                    @click="goToTask(index)"
                    class="px-4 py-1 bg-blue-500 text-white rounded hover:bg-blue-700"
                  >
                    Completar
                  </button>
                  <span v-else class="text-green-500 flex items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    Completada
                  </span>
                </div>
              </li>
            </ul>
            <div class="mt-8 mb-9">
              <h3 class="text-xl font-semibold mb-2">Progreso: {{progressPercentage}}%</h3>
              <div class="w-full bg-gray-200 rounded-full h-4">
                  <div
                    class="bg-blue-500 h-4 rounded-full"
                    :style="{ width: `${progressPercentage}%` }"
                  ></div>
                <p class="mt-2 text-sm">{{ completedTasks }} de {{ tasks.length }} tareas completadas</p>
              </div>
            </div>
          </div>
          <div class="flex justify-center items-center">
            <ul>
              <li class="mb-4 rounded-lg border bg-gray-50">
                <a href="#" class="flex p-4 items-center hover:text-gray-900 hover:bg-gray-100">
                  <svg class="w-6 h-6 mr-3 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m2 0a2 2 0 110-4H7a2 2 0 110 4zm0 0v4a4 4 0 004 4h4a4 4 0 004-4v-4"></path>
                  </svg>
                  <div>
                    <p>¿Interesado en conocer más? <span class="text-blue-500 hover:underline">Agendá una demo personal</span> para aprender sobre todas las funcionalidades que ofrece LumbreTravel.</p>
                  </div>
                </a>
              </li>
              <li class="mb-4 rounded-lg border bg-gray-50">
                <a href="#" class="flex p-4 items-center hover:text-gray-900 hover:bg-gray-100">
                  <svg class="w-6 h-6 mr-3 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 10h-6a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2v-6a2 2 0 00-2-2zM7 10h.01M7 6h.01M7 14h.01M3 10h.01M3 6h.01M3 14h.01M11 10h.01M11 6h.01M11 14h.01M15 10h.01M15 6h.01M15 14h.01"></path>
                  </svg>
                  <div>

                    <p>¿Tenés consultas o sugerencias? <span data-reamaze-lightbox="contact" class="text-blue-500 hover:underline">Iniciá un chat</span> con uno de nuestros miembros del equipo y estaremos encantados de ayudarte.</p>
                  </div>
                </a>
              </li>
              <!-- <li class="mb-4 rounded-lg border bg-gray-50">
                <a href="#" class="flex p-4 items-center hover:text-gray-900 hover:bg-gray-100">
                  <svg class="w-6 h-6 mr-3 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8V4m0 0a2 2 0 00-2-2h0a2 2 0 00-2 2v4M12 4v8m0 0a2 2 0 01-2 2H8m8-2h-4a2 2 0 00-2 2v4h8v-4a2 2 0 00-2-2h0a2 2 0 00-2-2z"></path>
                  </svg>
                  <div>
                    <p>Accedé a nuestra <span data-reamaze-lightbox="faq" class="text-blue-500 hover:underline">guía de primeros pasos</span> para familiarizarte rápidamente con todas las funcionalidades de LumbreTravel.</p>
                  </div>
                </a>
              </li> -->
              <li class="mb-4 rounded-lg border bg-gray-50">
                <a href="https://www.lumbretravel.com.ar/" target="_blank" class="flex p-4 items-center hover:text-gray-900 hover:bg-gray-100">
                  <svg class="w-6 h-6 mr-3 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 4h10M7 8h10m-4 8h4M7 12h10M7 16h4M3 4h.01M3 8h.01M3 12h.01M3 16h.01"></path>
                  </svg>
                  <div>
                    <p>Visitá nuestra <span class="text-blue-500 hover:underline">web</span> para conocer las últimas novedades y actualizaciones sobre LumbreTravel.</p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="block md:hidden">
        <ul class="grid grid-cols-2 gap-4 ">
          <li v-for="(menuItem, index) in mainMenuItems" :key="`'menuItem-'${index}`" class="rounded-lg border bg-gray-50" v-if="menuItem.path">
              <router-link
                :to="menuItem.path"
                class="flex p-2 items-center justify-center hover:text-gray-900 hover:bg-gray-100 flex-col h-full text-center "

              >
              <i :class="menuItem.icon"></i>
              <div class="ml-2"> {{ menuItem.name }} </div>
            </router-link>
          </li>
        </ul>
      </div>
    </template>
    <template v-else>
      <b-skeleton-img no-aspect height="178px"></b-skeleton-img>
    </template>
  </section>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  props: {
    widget: {
      type: Object
    },
    customization: {
      type: Object
    },
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tasks: [],
      isLoading: false,
      error: false,
      counter: {
        title: null,
        icon: null,
        value: null
      }
    }
  },
  computed: {
    ...mapGetters('settings', ['accentColor']),
    ...mapState('settings', ['mainMenuItems', 'loading']),
    completedTasks () {
      return this.tasks.filter(task => task.completed).length
    },
    progressPercentage () {
      return (this.completedTasks / this.tasks.length) * 100
    },
    pendingTasks () {
      return this.tasks.filter(task => !task.completed).length
    }
  },
  methods: {
    goToTask (index) {
      if (this.tasks[index]?.action?.type === 'route_push') {
        this.$router.push(this.tasks[index].action.target)
      }
    },
    ...mapActions('settings', ['getMainMenuSettings'])
  },
  async created () {
    try {
      this.isLoading = true
      const res = await commonsApi.axiosGetWrapper('/customer/onboardingtasks')
      this.tasks = res.data.tasks
      this.getMainMenuSettings()
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
.line-through {
  text-decoration: line-through;
}
</style>
